var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('div',{staticClass:"menu-left",on:{"click":_vm.outlogin}},[_vm._v("Wigor网站管理系统V1.0")]),_c('el-button',{staticClass:"menu-right",on:{"click":_vm.outlogin}},[_vm._v("退出")])],1),_c('el-container',[_c('AsidesView'),_c('el-main',[_c('router-view',[_vm._v("这是首页")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }